<template>
  <div class="client-message-button_block">
    <router-link
      v-if="isMeeting || isWaitingForPayment || isWorking"
      class="orange-ellipse_button"
      :to="{name: 'UpdatingWork', params: {workId: matching.work.id}}">
      オペレーターに変更依頼を出す
    </router-link>

    <div v-if="isMeeting || isWaiting" class="purple-ellipse_button">
      オペレーターの承諾を待っています
    </div>

    <router-link v-if="isWaitingForPayment" class="yellow-ellipse_button" :to="{name: 'Payment'}">
      決済
    </router-link>

    <div v-if="isWorking" class="purple-ellipse_button">
      オペレーターが作業中です
    </div>

    <button v-if="isInspecting" class="yellow-ellipse_button" @click="complete()">
      検収完了
    </button>

    <button v-if="isInspecting" class="purple-ellipse_button" @click="turnDown()">
      やり直してもらう
    </button>

    <router-link v-if="isCompleting" :to="{name: 'CreatingOperatorScore'}" class="purple-ellipse_button">
      オペレーターを評価する
    </router-link>
  </div>
</template>

<script>
  import STATUSES from "@/assets/js/constants/statuses";
  import caller from "@/assets/js/functions/firebase/cloud_functions/caller";
  import {mapGetters} from "vuex";

  export default {
    name: "ClientMessageButtonBlock",

    mixins: [caller],

    props: {
      matching: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        hasPushed: false,
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid'}),

      isMeeting() {
        return (this.matching.status === STATUSES.MEETING.name);
      },

      isWaitingForPayment() {
        return (this.matching.status === STATUSES.WAITING_FOR_PAYMENT.name);
      },

      isWaiting() {
        return (this.matching.status === STATUSES.WAITING.name);
      },

      isWorking() {
        return (this.matching.status === STATUSES.WORKING.name);
      },

      isInspecting() {
        return (this.matching.status === STATUSES.INSPECTION.name && !this.hasPushed);
      },

      isCompleting() {
        return (this.matching.status === STATUSES.COMPLETION.name);
      }
    },
    methods: {
      async complete() {
        const params = {matchingId: this.matching.id, userId: this.uid};
        await this.callFunction(
          'completeMatching',
          params
        ).then(() => {
          this.showSuccessMessage('検収を完了しました。');
          this.hasPushed = true;
          window.location.reload();
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        })
      },

      async turnDown() {
        const params = {matchingId: this.matching.id, userId: this.uid};
        await this.callFunction(
          'turnDownMatching',
          params
        ).then(() => {
          this.showSuccessMessage('検収を拒否しました。');
          this.hasPushed = true;
          window.location.reload();
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .client-message-button_block {
    display: flex;
    flex-flow: column;
    align-items: center;
    width: 100%;

    > .orange-ellipse_button, .yellow-ellipse_button, .purple-ellipse_button {
      margin: 1rem 0;
      width: 80%;
    }
  }
</style>